module.exports = __webpack_public_path__ + "static/05-b2d4ff02d7ad1a3531a012f67cf6487d.jpg";